<template>
    <div class="row">
        <div v-if="type === 'PASAPORTE'" class="form-group col-4">
            <PaisesPasaporteForm
                v-model="paisSeleccionado"
                :options="paises"
                :loading="loadingPaises"
                :disabled="disabled"
                label="País"
                :placeholder="$t('perfil_sga.pais')"
                :no-options-text="$t('formularios.seleccion_pais')"
            />
        </div>

        <FormInput
            :label="texto_documento"
            :infoText="infoText"
            :name="`${texto_documento}${index > 0 ? (' ' + index) : ''}`"
            :rules="getValidationRules()"
            :value="value"
            :disabled="!type || disabled || (type === 'PASAPORTE' && !paisSeleccionado)"
            :id="inputIdentifier"
            :data-cy="inputIdentifier"
            @input="$emit('input', $event)"
            :class="type === 'PASAPORTE' ? 'col-8' : 'col-12'"
            :placeholder="type === 'PASAPORTE' ? $t('formularios.seleccion_pais') : texto_documento"
        />
    </div>
</template>

<script setup>
    import { ref, watch, onMounted, getCurrentInstance, computed } from 'vue';
    import FormInput from "@/components/common/FormInput";
    import { useGetPaises } from '@/composables/common/useGetPaises';
    import PaisesPasaporteForm from "@/ui/PaisesPasaporteForm.vue";

    const props = defineProps({
        value: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: null
        },
        index: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        },
        infoText: {
            type: String,
            default: null
        },
        inputId: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['input']);
    const instance = getCurrentInstance();

    const texto_documento = ref("Documento");
    const paisSeleccionado = ref(null);
    const { paises, loadingPaises, cargarPaises } = useGetPaises();

    const updateTextoDocumento = tipo => {
        switch (tipo) {
            case 'DNI':
                texto_documento.value = 'DNI';
                break;
            case 'NIE':
                texto_documento.value = 'NIE';
                break;
            case 'NIF':
                texto_documento.value = 'NIF';
                break;
            case 'PASAPORTE':
                texto_documento.value = 'PASAPORTE';
                break;
            case 'OTROS':
                texto_documento.value = 'Documento';
                break;
            default:
                texto_documento.value = 'Documento';
                break;
        }
    };

    const getValidationRules = () => {
        if (props.type === 'PASAPORTE' && paisSeleccionado.value) {
            return {
                required: props.required,
                pasaporte: {
                    pais: paisSeleccionado.value.iso
                }
            };
        }

        if (props.type === 'NIF'){
            return {
                required: props.required,
                valid_nif_cif: true
            }
        }

        return {
            required: props.required,
            identificacion: { tipo: props.type }
        };
    };

    const inputIdentifier = computed(() => {
        return props.inputId || `valor-documento-${props.index}`;
    });

    watch(() => props.type, newVal => {
        updateTextoDocumento(newVal);
        if (newVal === 'PASAPORTE') {
            cargarPaises();
        } else {
            paisSeleccionado.value = null;
            emit('input', '');
        }
    });

    onMounted(() => {
        updateTextoDocumento(props.type);
        if (props.type === 'PASAPORTE') {
            cargarPaises();
        }
    });
</script>


